module.exports = __webpack_public_path__ + "media/logos/logo-yanosik-3e1a1839.svg";